import { FC } from 'react';

const SuccessIcon: FC<any> = (props) => {
    return (
        <svg
            width={186}
            height={180}
            viewBox="0 0 186 180"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx={95.5} cy={90.5} r={70.5} fill="url(#paint0_linear_3059_1758)" />
            <circle cx={178.467} cy={27.5} r={7.5} fill="#AF87D7" />
            <circle cx={20.0332} cy={10} r={10} fill="#AF87D7" />
            <circle cx={10.0332} cy={133} r={5} fill="#AF87D7" />
            <circle cx={165.533} cy={160.5} r={2.5} fill="#AF87D7" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M84.855 65.916h21.314c8.333 0 13.914 5.85 13.914 14.553v20.087c0 8.676-5.581 14.527-13.914 14.527H84.855c-8.334 0-13.939-5.851-13.939-14.527V80.469c0-8.702 5.605-14.553 13.939-14.553zM94.1 97.851l11.677-11.677c.836-.836.836-2.188 0-3.048a2.166 2.166 0 00-3.048 0L92.577 93.279l-4.302-4.302a2.166 2.166 0 00-3.049 0c-.835.835-.835 2.188 0 3.048l5.851 5.826c.418.418.959.615 1.5.615.565 0 1.106-.197 1.524-.615z"
                fill="#fff"
            />
            <circle cx={106.533} cy={4.5} r={2.5} fill="#AF87D7" />
            <circle cx={62.5332} cy={176.5} r={3.5} fill="#AF87D7" />
            <circle cx={122.033} cy={171} r={1} fill="#AF87D7" />
            <circle cx={170.533} cy={110.5} r={2.5} fill="#AF87D7" />
            <circle cx={1.0332} cy={75} r={1} fill="#AF87D7" />
            <defs>
                <linearGradient
                    id="paint0_linear_3059_1758"
                    x1={166}
                    y1={161}
                    x2={-1.77734}
                    y2={112.355}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#639" />
                    <stop offset={1} stopColor="#AF87D7" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default SuccessIcon;
